import { Collapse, Stack, styled, type SxProps, type Theme } from "@mui/material";

import { mergeSxProps } from "../../lib";
import { IconButton, type IconButtonProps } from "../IconButton";

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => <IconButton {...props} />)(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: "rotate(0deg)",
      },
    },
    {
      props: ({ expand }) => Boolean(expand),
      style: {
        transform: "rotate(180deg)",
      },
    },
  ],
}));

export interface CollapsibleBlockProps {
  title: string | React.ReactNode;
  expanded: boolean;
  onChange: () => void;
  children: React.ReactNode;
  LinkComponent: React.ElementType;
  sx?: SxProps<Theme>;
}

export function CollapsibleBlock(props: CollapsibleBlockProps) {
  const { title, children, LinkComponent, expanded, onChange, sx } = props;

  return (
    <Stack sx={mergeSxProps({ cursor: "pointer" }, sx)} onClick={onChange}>
      <Stack direction="row" alignItems="center" gap={2}>
        <Stack flex={1}>{title}</Stack>
        <ExpandMore
          variant="ghost"
          iconType="chevron-down"
          size="small"
          expand={expanded}
          LinkComponent={LinkComponent}
        />
      </Stack>

      <Collapse unmountOnExit in={expanded}>
        {children}
      </Collapse>
    </Stack>
  );
}
